import { useI18n } from "vue-i18n";
import { ref } from 'vue';
import { ElMenu } from 'element-plus';
import { ElMenuItem } from 'element-plus';
import { ElSubMenu } from 'element-plus';
import { ElButton } from 'element-plus';
import 'element-plus/es/components/menu/style/index'
import 'element-plus/es/components/menu-item/style/index'
import 'element-plus/es/components/sub-menu/style/index'
import 'element-plus/es/components/button/style/index'

const __default__ = {
  setup() {
    let {
      t,
      locale
    } = useI18n({
      messages: {
        'en': {
          "__link_index": "Index",
          "__link_code_of_conduct": "Code of Conduct",
          "__link_manual_of_new_version": "Latest Manual",
          "__link_historical_version": "Historical Versions",
          "__link_v3_manual": "Manual V3",
          "__link_v2_manual": "Manual V2",
          "__link_enterprise_payment": "Buy Enterprise Version",
          "__link_enterprise_service": "Shared Atomic Enterprise Service",
          "__link_gitlab": "Gitlab",
          "__link_about": "About Us",
          "__link_int_api": "Int API:",
          "__link_uint_api": "Unsigned Int API:",
          "__link_boolfloat_api": "Bool and Float API:",
          "__link_bytearray_api": "Bytearray API:",
          "__link_shared_memory_api": "Shared Memory API:",
          "__link_dict_api": "Shared Dict API:",
          "__link_atomic_object_api": "Generic Atomic Object API:",
          "__link_list_api": "List API:",
          "__link_string_api": "String API:",
          "__link_set_api": "Set API:",
          "__link_procedure_oriented_object_api": "Procedure Oriented APIs:",
          "__link_atomic_tools": "Atomic Tools",
          "__link_atomic_api_example": "Lock-free API Example"
        },
        'zh_CN': {
          "__link_index": "主页",
          "__link_code_of_conduct": "编程原则",
          "__link_manual_of_new_version": "新版文档",
          "__link_historical_version": "历史版本",
          "__link_v3_manual": "V3文档",
          "__link_v2_manual": "V2文档",
          "__link_enterprise_payment": "购买企业版",
          "__link_enterprise_service": "企业版服务",
          "__link_gitlab": "Gitlab",
          "__link_about": "关于我们",
          "__link_int_api": "整型API:",
          "__link_uint_api": "无符号整形API：",
          "__link_boolfloat_api": "布尔和浮点API：",
          "__link_bytearray_api": "字节数组API：",
          "__link_shared_memory_api": "共享内存API：",
          "__link_dict_api": "共享字典API：",
          "__link_atomic_object_api": "通用原子对象API：",
          "__link_list_api": "列表API：",
          "__link_string_api": "字符串API：",
          "__link_set_api": "集合API：",
          "__link_procedure_oriented_object_api": "面向过程的API：",
          "__link_atomic_tools": "安装工具",
          "__link_atomic_api_example": "无需用锁API示例"
        },
        'zh_HK': {
          "__link_index": "主頁",
          "__link_code_of_conduct": "編程原則",
          "__link_manual_of_new_version": "新版文檔",
          "__link_historical_version": "曆史版本",
          "__link_v3_manual": "V3文檔",
          "__link_v2_manual": "V2文檔",
          "__link_enterprise_payment": "購買企業版",
          "__link_enterprise_service": "企業版服務",
          "__link_gitlab": "Gitlab",
          "__link_about": "關於我們",
          "__link_int_api": "整型API:",
          "__link_uint_api": "無符號整形API：",
          "__link_boolfloat_api": "布爾和浮點API：",
          "__link_bytearray_api": "字節數組API：",
          "__link_shared_memory_api": "共享內存API：",
          "__link_dict_api": "共享字典API：",
          "__link_atomic_object_api": "通用原子對象API：",
          "__link_list_api": "列錶API：",
          "__link_string_api": "字符串API：",
          "__link_set_api": "集合API：",
          "__link_procedure_oriented_object_api": "面嚮過程的API：",
          "__link_atomic_tools": "安裝工具",
          "__link_atomic_api_example": "無需用鎖API示例"
        },
        'zh_TW': {
          "__link_index": "主頁",
          "__link_code_of_conduct": "編程原則",
          "__link_manual_of_new_version": "新版文檔",
          "__link_historical_version": "曆史版本",
          "__link_v3_manual": "V3文檔",
          "__link_v2_manual": "V2文檔",
          "__link_enterprise_payment": "購買企業版",
          "__link_enterprise_service": "企業版服務",
          "__link_gitlab": "Gitlab",
          "__link_about": "關於我們",
          "__link_int_api": "整型API:",
          "__link_uint_api": "無符號整形API：",
          "__link_boolfloat_api": "布爾和浮點API：",
          "__link_bytearray_api": "字節數組API：",
          "__link_shared_memory_api": "共享內存API：",
          "__link_dict_api": "共享字典API：",
          "__link_atomic_object_api": "通用原子對象API：",
          "__link_list_api": "列錶API：",
          "__link_string_api": "字符串API：",
          "__link_set_api": "集合API：",
          "__link_procedure_oriented_object_api": "面嚮過程的API：",
          "__link_atomic_tools": "安裝工具",
          "__link_atomic_api_example": "無需用鎖API示例"
        }
      }
    });
    const activeIndex = ref('1');
    const isCollapse = ref("none");
    return {
      t,
      locale,
      activeIndex,
      isCollapse
    };
  },
  components: {
    ElMenu,
    ElMenuItem,
    ElSubMenu,
    ElButton
  }
};
import { useCssVars as _useCssVars } from 'vue';
const __injectCSSVars__ = () => {
  _useCssVars(_ctx => ({
    "v5a2de8c6": _ctx.isCollapse,
    "v165f7c8a": _ctx.locale == 'en' ? '2.1rem' : '1.45rem'
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;